<mat-divider></mat-divider>
<footer>
    电话：010-67309068 E-mail：service@healthbit.cn
</footer>